import React from 'react';
import SectionHeader from '../SectionHeader';
import { useState, useEffect } from 'react';
import './schoolcollaboration.css';

const schools = [
  { id: '1', name: 'Gateway', src: 'images/Collaboration_pics/GE-Logo2.png' },
  {
    id: '2',
    name: 'SPS',
    src: 'images/Collaboration_pics/sps.jpeg',
  },
  {
    id: '3',
    name: 'Seth Anandram Jaipuria School',
    src: 'images/Collaboration_pics/SAJS.jpg',
  },
  {
    id: '4',
    name: 'HRM Global School',
    src: 'images/Collaboration_pics/HRM-Logo.png',
  },
  {
    id: '5',
    name: 'Kothari School',
    src: 'images/Collaboration_pics/Kothari.png',
  },
  {
    id: '6',
    name: 'LVISG',
    src: 'images/Collaboration_pics/LVISG.png',
  },
  {
    id: '7',
    name: "St. Xavier's Higher Secondary School",
    src: 'images/Collaboration_pics/XavLogo.png',
  },
  {
    id: '8',
    name: 'RAN Public School',
    src: 'images/Collaboration_pics/school-logo.png',
  },
  {
    id: '9',
    name: 'MBS International School',
    src: 'images/Collaboration_pics/mbs_school.png',
  },
  {
    id: '10',
    name: 'Lycée Suger',
    src: 'images/Collaboration_pics/lycee_suger_logo.jpg',
  },
  {
    id: '11',
    name: 'TCHM Tuli School',
    src: 'images/Collaboration_pics/Tuli.jpg',
  },
  {
    id: '12',
    name: 'Sparsh Global School',
    src: 'images/Collaboration_pics/sparsh_logo.png',
  },
  {
    id: '13',
    name: 'Scottish High International School',
    src: 'images/Collaboration_pics/scottish.png',
  },
  {
    id: '14',
    name: 'Bright Scholar',
    src: 'images/Collaboration_pics/bright_scholar.png',
  },
  {
    id: '15',
    name: 'Hope Town',
    src: 'images/Collaboration_pics/hope_town.png',
  },
  {
    id: '16',
    name: 'MBS College',
    src: 'images/Collaboration_pics/mbs_college.png',
  },
  {
    id: '17',
    name: 'LVISNE',
    src: 'images/Collaboration_pics/LVISNE.png',
  },
  {
    id: '18',
    name: 'Prudence',
    src: 'images/Collaboration_pics/prudence.png',
  },
  {
    id: '19',
    name: 'Presidium',
    src: 'images/Collaboration_pics/presidium.jpg',
  },
  {
    id: '20',
    name: 'HHXLS',
    src: 'images/Collaboration_pics/HXLS.png',
  },
  {
    id: '21',
    name: 'St. Xaviers',
    src: 'images/Collaboration_pics/st.xaviers.png',
  },
  {
    id: '22',
    name: 'Manav Rachna',
    src: 'images/Collaboration_pics/manav_rachna.jpg',
  },
  {
    id: '23',
    name: 'GD Goenka',
    src: 'images/Collaboration_pics/gd_goenka.png',
  },
  {
    id: '24',
    name: 'Presidency',
    src: 'images/Collaboration_pics/presidency.png',
  },
];

const SchoolCollaborations = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <>
      <SectionHeader firstTxt="Schools" lastTxt="We have Worked with" />
      <section className="school-section">
        <div className="school-container">
          {/* Schools Grid - Masonry/Staggered Layout */}
          <div className="schools-grid">
            {schools.map((school, index) => {
              return (
                <div
                  key={school.id}
                  className={`school-card-wrapper ${index % 2 === 1 ? 'stagger' : ''} ${isVisible ? 'visible' : 'invisible'}`}
                  style={{
                    transitionDelay: isVisible ? `${index * 40}ms` : '0ms',
                  }}
                >
                  {/* Card */}
                  <div className="school-card">
                    {/* Logo Container */}
                    <div className="school-card-content">
                      <img
                        src={school.src}
                        alt={school.name}
                        title={school.name}
                        className="school-logo"
                        onError={(e) => {
                          e.target.src =
                            'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100"%3E%3Crect fill="%23F3E8FF" width="100" height="100" rx="12"/%3E%3Ctext x="50" y="50" font-size="11" fill="%23D8B4FE" text-anchor="middle" dominant-baseline="middle" font-family="sans-serif"%3ELogo%3C/text%3E%3C/svg%3E';
                        }}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default SchoolCollaborations;
